module.exports = __webpack_public_path__ + "img/humidity.f4cc325d.png";